
<template>
  <div class="layout--full-page">
    <top-bar class="absolute"></top-bar>
    <router-view></router-view>
    <vue-fab size="big" :mainBtnColor="'#ff0000'" @clickMainBtn="sosWhatsApp" :icon="'sms'" :menu="[]">
    </vue-fab>
  </div>
</template>

<script>
  import topBar from './FullPageTopBar'

  export default {
    components: {
      topBar
    },
    data() {
      return {}
    },
    methods: {
      sosWhatsApp() {
        window.open("https://wa.me/message/ML4LRUPSQ5ATE1", "_blank");
      },
    }
  }
</script>
